import type { ReactNode } from 'react';

export type PageTitleProps = {
	title: ReactNode;
	append?: ReactNode;
	prepend?: ReactNode;
};

export const PageTitle = ({ title, append, prepend }: PageTitleProps) => {
	return (
		<div className="page-title-wrap">
			{prepend ? <span className="page-title-prepend">{prepend}</span> : null}
			<h1 className="page-title">{title}</h1>
			{append ? <span className="page-title-append">{append}</span> : null}
		</div>
	);
};

export default PageTitle;
